import { Box, Divider, Typography } from '@mui/material';
import NoHealthRecordDataCard, { HealthRecordCategory } from 'components/NoHealthRecordDataCard';
import PatientDetailsCard from 'components/PatientDetailsCard';
import UserAddedToolTip from 'pages/Dashboard/components/UserAddedToolTip';
import { ShowMoreDrawerChildProps, sliceForShowMore } from 'pages/Dashboard/ShowMoreDrawer';
import { PatientHospitalization } from 'pages/Dashboard/types/hospitalizations.types';
import * as React from 'react';
import theme from 'theme';
import { googleDateToDateString } from 'utils/dateUtils';


export interface HospitalizationsCardProps extends ShowMoreDrawerChildProps {
  gridSize?: number;
  patientHospitalizations?: PatientHospitalization[];
  isNewUi?: boolean;
}

export default function HospitalizationsCard({
  gridSize,
  drawerMode = false,
  patientHospitalizations = [],
  onShowMore,
  isNewUi,
}: HospitalizationsCardProps): JSX.Element | null {
  const data = sliceForShowMore(patientHospitalizations, !drawerMode);

  return (
    <PatientDetailsCard
      title='Hospitalizations'
      showHeader={!drawerMode && patientHospitalizations?.length > 0}
      gridProps={{ xs: 12, md: !drawerMode ? gridSize : undefined }}
      viewDetailsBtnLabel='View all'
      showViewDetails={!drawerMode && data.length > 3 && !!onShowMore}
      onViewDetails={onShowMore as VoidFunction}
      key='hospitalizations'
      showSubHeader={false}
    >
      {patientHospitalizations?.length === 0 && isNewUi ? (
        <NoHealthRecordDataCard
          title='No hospitalizations found'
          description='Data will be available here once there is a activity to record'
          healthRecordCategory={HealthRecordCategory.hospitalizations}
        />
      ) : (
        data.map((hospitalization, index) => (
          <>
            <Box display='flex' flexDirection='row' justifyContent='space-between'>
              <Box display='flex' flexDirection='column'>
                <Box key={`hospitalization-${hospitalization.id}`}>
                  <Typography variant='body2' color='text.secondary'>
                    {`${googleDateToDateString(hospitalization.startDate)}
                        -
                  ${googleDateToDateString(hospitalization.endDate)}`}
                  </Typography>

                  {hospitalization.locations.map((location) => (
                    <Typography variant='body1' color='text.primary'>{`${location.name} `}</Typography>
                  ))}
                  {hospitalization.diagnosis.map((patientDiagnosis) => (
                    <Typography
                      key={patientDiagnosis.id}
                      variant='body2'
                      color='text.secondary'
                    >
                      {patientDiagnosis.name}
                    </Typography>
                  ))}
                </Box>
              </Box>
              <UserAddedToolTip source={hospitalization?.source} />
            </Box>
            {index < data.length - 1 && (
              <Divider sx={{ borderColor: theme.custom.colors.borderColor, my: 1 }} />
            )}
          </>
        ))
      )}
    </PatientDetailsCard>
  );
}
